import {PromoterInterface} from "@/types/Promoter";

export class Promoter implements PromoterInterface {
  public id!: number;
  public name!: string;
  public street!: string;
  public streetNr!: string;
  public plz!: string;
  public city!: string;
  public country!: string;
  public contactVorname!: string;
  public contactLastname!: string;
  public email!: string;
  public phone!: string;
  public logo!: string;
  public website!: string;
  public facebook?: string;
  public youtube?: string;
  public twitter?: string;
  public description!: string;


  constructor({id, name, street, streetNr, plz, city, country, contactVorname, contactLastname, email, phone, logo, website, facebook, youtube, twitter, description}: PromoterInterface) {
    this.id = id;
    this.name = name;
    this.street = street;
    this.streetNr = streetNr;
    this.plz = plz;
    this.city = city;
    this.country = country;
    this.contactVorname = contactVorname;
    this.contactLastname = contactLastname;
    this.email = email;
    this.phone = phone;
    this.logo = logo;
    this.website = website;
    this.facebook = facebook;
    this.youtube = youtube;
    this.twitter = twitter;
    this.description = description;
  }
}
